import {createContext, useContext} from 'react';
import {SendTxResources} from './SendTxContainer';

export const [SendTxResourcesContextProvider, useSendTxResources] = (context => [
    context.Provider,
    () => useContext(context)(),
])(
    createContext((): SendTxResources => {
        throw new Error('SendTxResourcesContext not provided');
    })
);
